import { cn, Label } from '@src/components/ui';


/**
 * The shared base-field shell: a vertical stack of an optional label-above, the
 * control, and the reserved helper/error line below. Every base field
 * (TextField / SelectField / AutocompleteField / SuggestField / CheckboxField)
 * renders its control as `children` here so label placement and error styling
 * live in one place.
 *
 * `id` wires the label to the control; omit `label` for controls that carry
 * their own inline label (CheckboxField).
 */
function FieldShell({ label, id, error = false, helperText = ' ', className, children }) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label
        ? (
          <Label htmlFor={id}>{label}</Label>
        )
        : null}

      {children}

      <p className={cn('min-h-4 text-xs', error ? 'text-danger' : 'text-ink-subtle')}>
        {helperText}
      </p>
    </div>
  );
}

FieldShell.displayName = 'FieldShell';
export default FieldShell;
